import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import moment from "moment";
import { toast } from "react-toastify";
import ConfirmationPayrollComponent from "./Component/ConfirmationPayrollComponent";

const ConfirmationPayroll = () => {
  const dispatch = useDispatch();

  const intialFilterData = [
    // {
    //   label: "Email",
    //   value: { value: 0, label: "Official" },
    // },
    { label: "Branch", value: { value: 2, label: "NSS-Main" } },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const [payrollData, setPayrollData] = useState([]);
  const [filterFormData, setFilterData] = useState(intialFilterData);
  const [shiftOptlist, setShiftOptlist] = useState([]);
  const [departmentlist, setDepartmentlist] = useState([]);
  const [taxRegimelistset, setTaxRegimelist] = useState([]);
  const [designationOptList, setDesignationOptList] = useState([]);
  const [monthOptList, setMonthOptList] = useState([]);
  const [getTableData, setGetTableData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [branchOptList, setBranchOptList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formattedKeys, setFormattedKeys] = useState([]);
  const [totals, setTotals] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedResources, setSelectedResources] = useState([]);
  const [approvedByValue, setApprovedByValue] = useState(null);
  const [userName, setUserName] = useState("");
  const [apiStatus, SetApiStatus] = useState("")
  const [approvedByOptions, setApprovedByOptions] = useState([]);


  useEffect(() => {
    dispatch(updateNavbarHeading("Confirmation Payroll"));
  }, []);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    if (user.DefaultContactID) {
      setUserName(user.DefaultContactID);
    }
  }, []);
  useEffect(() => {
    fetchConfirmationPayrollMaster();
  }, []);
  const formDatas = [
    { name: "Branch", type: "Select", options: [...branchOptList] },
    { name: "Shift", type: "Select", options: [...shiftOptlist] },
    { name: "Department", type: "Select", options: [...departmentlist] },
    // { name:"Tax Regime", type:"Select", options: [...taxRegimelistset]},
    { name: "Designation", type: "Select", options: [...designationOptList] },
    { name: "Month", type: "Select", options: [...monthOptList] },
    { name: "Employee", type: "Select", options: [...employeeList] },
  ];

  const handleChange = (e, name) => {
    // Convert the date to "YYYY-MM" format if it's a valid date
    const formattedValue = moment(e, "DD-MMM-YYYY").isValid()
      ? moment(e, "DD-MMM-YYYY").format("YYYY-MM")
      : e;
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? {
              ...item,
              value: formattedValue !== undefined ? formattedValue : e,
            }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: formattedValue !== undefined ? formattedValue : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleGetData = async () => {
    const monthID = filterFormData.find((o) => o.label === "Month")?.value?.value
    if (!monthID) {
      return toast.error("Month field is required.")
    }
    try {
      SetApiStatus(undefined)
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/confirm-payroll-data?p_MonthID=${filterFormData.find((o) => o.label === "Month")
          ? filterFormData.find((o) => o.label === "Month").value.value
          : 0
        }&p_ShiftID=${filterFormData.find((o) => o.label === "Shift")
          ? filterFormData.find((o) => o.label === "Shift").value.value
          : ''
        }&p_DepartmentID=${filterFormData.find((o) => o.label === "Department")
          ? filterFormData.find((o) => o.label === "Department").value.value
          : ""
        }&p_DesignationID=${filterFormData.find((o) => o.label === "Designation")
          ? filterFormData.find((o) => o.label === "Designation").value.value
          : ""
        }&p_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value.value
          : ""
        }`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status)
        const cleanedData = response?.data?.data;
        setGetTableData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const fetchConfirmationPayrollMaster = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/confirm-payroll`
      );

      if (response.status === 200) {
        // Shift List
        const shiftList = response?.data?.shift?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setShiftOptlist(shiftList);
        // Department List
        const depList = response?.data?.department?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setDepartmentlist(depList);
        // Tax Regime List
        const taxlist = response?.data?.regime?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setTaxRegimelist(taxlist);
        // Designation List
        const designationlist = response?.data?.designation?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setDesignationOptList(designationlist);
        // Month List
        const monthlist = response?.data?.calendermonth?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setMonthOptList(monthlist);
        // Employee List
        const emplist = response?.data?.employee?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmployeeList(emplist);
        // Branch List
        const branchlist = response?.data?.branch?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setBranchOptList(branchlist);
        const approvedlist = response?.data?.executives?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setApprovedByOptions(approvedlist);
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };

  const dataSets = { "Confirmation Payroll": getTableData };

  const checkBoxRequiredMap = {
    "Confirmation Payroll": true, // Checkbox required
    "Attendance/Leave Issues": false, // Checkbox not required
  };

  const columns = {
    Code: { text: "NSS-Code", align: "center", visible: true },
  };



  useEffect(() => {
    if (getTableData.length > 0) {
      const extractedKeys = [];

      // Extract column keys dynamically that start with "$"
      Object.keys(getTableData[0]).forEach((key) => {
        if (key.startsWith("$")) {
          const newKey = key.replace("$", "").replace(/_/g, " "); // Format key
          extractedKeys.push({ key: key, label: newKey });
        }
      });



      // Combine extractedKeys and totalDeductionsColumn into a single array
      const updatedFormattedKeys = [...extractedKeys];

      // Update the state
      setFormattedKeys(updatedFormattedKeys);
    }
  }, [getTableData]);
  useEffect(() => {
    if (getTableData.length > 0) {
      const sums = {};

      formattedKeys.forEach(({ key }) => {
        sums[key] = getTableData.reduce(
          (acc, item) => acc + (Number(item[key]) || 0),
          0
        );
      });

      setTotals(sums);
    }
  }, [getTableData, formattedKeys]);

  const columnHeadersMap = {
    "Confirmation Payroll": [
      // { key: "EmployeeCode", label: "Employee Code" },
      { key: "Employee", label: "Employee" },
      ...formattedKeys
    ],
  };


  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);

    if (checked) {
      const newSelectedItems = {};
      const newSelectedResources = getTableData.map((item) => {
        const id = String(item.ContactID); // or EmployeeID if that is unique
        newSelectedItems[id] = true;
        return { ...item, tmpIsAllowed: 1 };
      });

      setSelectedItems(newSelectedItems);
      setSelectedResources(newSelectedResources);
    } else {
      setSelectedItems({});
      setSelectedResources([]);
    }
  };


  const handleCheckboxChange = (e, id, item) => {
    const isChecked = e.target.checked;

    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = {
        ...prevSelectedItems,
        [id]: isChecked,
      };

      const allSelected =
        Object.keys(updatedSelectedItems).length === payrollData.length &&
        Object.values(updatedSelectedItems).every(Boolean);
      setSelectAllChecked(allSelected);

      return updatedSelectedItems;
    });

    setSelectedResources((prevSelectedResources) => {
      if (isChecked) {
        return [...prevSelectedResources, { ...item, tmpIsAllowed: 1 }]; // Set tmpIsAllowed to 1
      } else {
        return prevSelectedResources
          .map((resource) =>
            resource.ContactID === item.ContactID
              ? { ...resource, tmpIsAllowed: 0 } // Set tmpIsAllowed to 0 before filtering
              : resource
          )
          .filter((resource) => resource.ContactID !== item.ContactID);
      }
    });
  };


  const [submitButtonStatus, setSubmitButtonStatus] = useState(false)
  const handleSubmitButton = async () => {
    setSubmitButtonStatus(true)
    if (selectedResources.length === 0) {
      toast.error("Please select at least one employee", {
        position: "top-right",
      });
      return; // Exit the function early if no employees are selected
    }

    try {
      const filterValue = (label) => {
        const item = filterFormData.find((o) => o.label === label);
        return item ? item.value.value : 0;
      };

      let response = await PostServiceCaller(
        `${API_URL}rujul/finance/confirm-payroll`,
        {
          ConfirmationPayroll: {
            p_MonthID: filterValue("Month"),
            p_ShiftID: filterValue("Shift"),
            p_DepartmentID: filterValue("Department")
              ? moment(filterValue("Department"))
              : "",
            p_DesignationID: filterValue("Designation")
              ? moment(filterValue("Designation"))
              : "",
            p_EmployeeID: filterValue("Employee"),
            PEmployeeID: filterValue("Tax Regime"),
            BranchID: filterValue("Branch"),
            ApprovedBy: userName,
          },
          ConfirmationPayrollLine: selectedResources,
        },
        "post"
      );

      if (response?.status === 200) {
        setSubmitButtonStatus(false)
        toast.success("Data Submitted Successfully", {
          position: "top-right",
        });

        setTimeout(() => {
          window.location.reload();
        }, 2000)
      }
    } catch (error) {
      console.error("Error while posting:", error);
    }
  };


  const handleApprovedByChange = (selectedOptions) => {
    setApprovedByValue(selectedOptions.value);
  };


  const handleReset = () => {
    setFilterData(intialFilterData)
    setGetTableData([])
  }
  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="row">
          <ConfirmationPayrollComponent

            dataSets={dataSets}
            isSubmitStatus={submitButtonStatus}
            columnHeadersMap={columnHeadersMap}
            columns={columns}
            itemsPerPage={10}
            isSorting={true}
            isFilterRequired={true}
            searchTerm={searchTerm}
            formDatas={formDatas}
            isCheckBoxRequired={true}
            formattedKeys={formattedKeys}
            totals={totals}
            isRequiredStatus={true}
            isApiStatus={apiStatus}
            handleReset={handleReset}
            setSearchTerm={setSearchTerm}
            checkBoxRequiredMap={checkBoxRequiredMap}
            selectedResource={selectedResources}
            selectAllChecked={selectAllChecked}
            handleCheckboxChange={handleCheckboxChange}
            handleSelectAllChange={handleSelectAllChange}
            filterFormData={filterFormData}
            ApprovedBYOptions={approvedByOptions}
            handleGetData={handleGetData}
            handleSubmitButton={handleSubmitButton}
            handleApprovedByChange={handleApprovedByChange}
            handleChange={handleChange}
            userName={userName}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPayroll;
